import script from "./TopNav.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNav.vue?vue&type=script&setup=true&lang=js"

import "./TopNav.vue?vue&type=style&index=0&id=5a9da3fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9da3fe"]])

export default __exports__